// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");

function RadioButtonInput(props) {
  var __value = props.value;
  var __className = props.className;
  var __indeterminate = props.indeterminate;
  var indeterminate = __indeterminate !== undefined ? __indeterminate : false;
  var className = __className !== undefined ? __className : "";
  var value = __value !== undefined ? __value : "";
  var domElement = React.useRef(null);
  React.useEffect((function (param) {
          var y = Belt_Option.getExn(Caml_option.nullable_to_opt(domElement.current));
          y.indeterminate = indeterminate;
        }), []);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("input", {
                      ref: Caml_option.some(domElement),
                      className: "cursor-pointer custom-radio",
                      id: "box-shadow",
                      checked: indeterminate ? false : props.checked,
                      type: "radio",
                      value: value,
                      onChange: props.handleChange
                    }),
                JsxRuntime.jsx("span", {
                      children: props.label,
                      className: "ml-2 font-16-px leading-normal whitespace-normal w-11/12 align-top"
                    })
              ],
              className: "items-center mb-4 " + className
            });
}

var make = RadioButtonInput;

exports.make = make;
/* react Not a pure module */
